import React, { Fragment, useCallback } from 'react';
import { MixedTags } from './mixedTags';

const FormulaInput = ({
  tags, inputElmRef, setDefaultExpression, initValue,
}) => {
  const handleChange = useCallback((e) => {
    setDefaultExpression(e.detail.value);
  }, []);

  const settings = {
    whitelist: tags,
    pattern: /@/,
    dropdown: {
      enabled: 0,
      position: 'bottom',
    },
    enforceWhitelist: true,
    editTags: false,
  };

  return (
    <Fragment>
      <MixedTags
        settings={settings}
        onChange={handleChange}
        value={initValue}
        inputElmRef={inputElmRef}
        defaultValue={initValue}
      />
      <div className="formula-input-tag__help" style={{ fontSize: '12px', marginTop: '5px', fontWeight: '400' }}>
        You can enter the formula here. To use a variable, type @ character.
      </div>
      <div className="formula-input-tag__help" style={{ fontSize: '12px', marginTop: '5px', fontWeight: '400' }}>
        Only 'Number' type fields can be used for calculation.
      </div>
    </Fragment>
  );
};

export default FormulaInput;
